// Non-blocking notices for the local-draft backup (common/localDraftStore.es6):
// "local work loaded - remember to save" and the storage-quota warning.
// Same window-event bridge as ServerErrorToast.
import React, { useEffect, useState } from "react";
import i18n from "i18next";
import { Snackbar, Alert } from "@mui/material";
import { LOCAL_DRAFT_NOTICE_EVENT } from "../../../common/localDraftStore.es6";

const LocalDraftToast = () => {
  const [kind, setKind] = useState(null);

  useEffect(() => {
    const handle = (e) => setKind(e.detail && e.detail.kind);
    window.addEventListener(LOCAL_DRAFT_NOTICE_EVENT, handle);
    return () => window.removeEventListener(LOCAL_DRAFT_NOTICE_EVENT, handle);
  }, []);

  return (
    <Snackbar
      open={!!kind}
      autoHideDuration={8000}
      onClose={() => setKind(null)}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
    >
      <Alert severity={kind === "quota" ? "warning" : "info"} onClose={() => setKind(null)}>
        {kind === "quota"
          ? i18n.t("localDraft.quotaWarning")
          : kind === "targetRemoved"
            ? i18n.t("localDraft.targetRemovedNotice")
            : i18n.t("localDraft.loadedNotice")}
      </Alert>
    </Snackbar>
  );
};

export default LocalDraftToast;
